export default function DotDensity() {
  return (
    <p>
      Renderer visual editor under work. Please edit it through json editor by
      pressing the "Renderer" button
    </p>
  );
}
